import { Component, input, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-button-icon',
    imports: [],
    templateUrl: './button-icon.component.html',
    styleUrl: './button-icon.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true
})
export class ButtonIconComponent {
  @Input() iconName!: string;
  colorPicker = input<string>();
  @Input() iconSize:string = '36px';

}
